import { ArrowUp, ShoppingBag } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ShopifyCartSidebar } from './ShopifyCartSidebar';
import { useFloatingActions } from '@/contexts/FloatingActionsContext';
import { useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';

export const FloatingActions = () => {
  const { showFloatingActions } = useFloatingActions();
  const location = useLocation();

  // Don't show floating actions on size guide page (used in popups)
  if (location.pathname === '/size-guide') {
    return null;
  }

  const scrollToTop = () => {
    if (typeof window === 'undefined') return;
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className="fixed bottom-6 right-6 z-[9999] flex flex-col gap-3">
      {/* Back to Top Button */}
      <Button
        onClick={scrollToTop}
        size="icon"
        className={cn(
          "h-12 w-12 rounded-full bg-background/80 backdrop-blur-sm border border-border/50 shadow-lg",
          "hover:bg-background/90 hover:scale-110 transition-all duration-200",
          "text-foreground hover:text-primary",
          showFloatingActions 
            ? "opacity-100 translate-y-0 pointer-events-auto" 
            : "opacity-0 translate-y-2 pointer-events-none"
        )}
        aria-label="Back to top"
      >
        <ArrowUp className="h-5 w-5" />
      </Button>

      {/* Floating Cart Button */}
      <ShopifyCartSidebar showBadgeOnScroll={true}>
        <Button
          size="icon"
          className={cn(
            "h-12 w-12 rounded-full bg-primary/90 backdrop-blur-sm shadow-lg",
            "hover:bg-primary hover:scale-110 transition-all duration-200",
            "text-primary-foreground transition-all duration-200",
            showFloatingActions 
              ? "opacity-100 translate-y-0 pointer-events-auto" 
              : "opacity-0 translate-y-2 pointer-events-none"
          )}
          aria-label="Shopping cart"
        >
          <ShoppingBag className="h-5 w-5" />
        </Button>
      </ShopifyCartSidebar>
    </div>
  );
};